import classNames from 'classnames';
import React from 'react';
import { Thead as ResponsiveThead } from 'react-super-responsive-table';
import styles from './index.module.scss';

export const Thead: React.FC<React.HTMLAttributes<HTMLTableSectionElement>> = props => {
  const { children, className, ...rest } = props;
  const containerClass = classNames(styles.thead, className);

  return (
    <ResponsiveThead {...rest} className={containerClass}>
      {children}
    </ResponsiveThead>
  );
};
